export default __webpack_public_path__ + "static/media/image-fuzzy-bot-locked-1.eff56012.jpg";